export const EMPLOYEE_USER_TYPE = "EMPLOYEE";
export const ADMIN_USER_TYPE = "ADMIN";
